module.exports = __webpack_public_path__ + "static/media/File.100cea2d.png";